import { graphql } from "@/data-access/graphql";

export const GetFeedVolumeChartData = graphql(`
  query getFeedVolumeChart(
    $input: NewsFeedChartInput!
    $filters: FeedArticleProjectionFilter!
  ) {
    newsFeedChartV2(input: $input, filters: $filters) {
      startOfPeriod
      endOfPeriod
      volume
      chartData
    }
  }
`);

export type GetFeedVolumeChartVariablesType = Parameters<
  Exclude<typeof GetFeedVolumeChartData.__apiType, undefined>
>[0];

export type NewsFeedChartData = NonNullable<
  Awaited<
    ReturnType<Exclude<(typeof GetFeedVolumeChartData)["__apiType"], undefined>>
  >["newsFeedChartV2"]
>[number];
